var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeActive = function SvgHomeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFE9E9",
    stroke: "#EFE9E9",
    strokeWidth: 1.5,
    d: "M7.396 3.808a2.25 2.25 0 0 1 3.141.04l5.14 5.14a.25.25 0 0 1 .073.176v7.086h-3v-3.375a3.75 3.75 0 1 0-7.5 0v3.375h-3V8.805c0-.069.028-.135.078-.182zM9 12.125c.621 0 1.125.504 1.125 1.125v3h-2.25v-3c0-.621.504-1.125 1.125-1.125Z"
  })));
};
export default SvgHomeActive;